export default "__VITE_ASSET__DiMVNqgV__"